import { render } from "./HeartRateMonitor.vue?vue&type=template&id=01528fb9&scoped=true"
import script from "./HeartRateMonitor.vue?vue&type=script&lang=js"
export * from "./HeartRateMonitor.vue?vue&type=script&lang=js"

import "./HeartRateMonitor.vue?vue&type=style&index=0&id=01528fb9&scoped=true&lang=scss"
import "./HeartRateMonitor.vue?vue&type=style&index=1&id=01528fb9&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01528fb9"]])

export default __exports__